<template>
    <div class="login">
        <v-card color="transparent" dark width="500" class="mx-auto mt-5" >
            <div class="text-center pt-4">
                <v-avatar :tile="true">
                    <img :src="require('@/assets/syn_logo.svg')" alt="logo">
                </v-avatar>
            </div>
            <v-card-title>
                <span class="px-3 synThickFont synLargeFont marginAlignCenter">Login</span>
            </v-card-title>

            <v-card-text >
                <v-form ref="loginForm" v-on:submit.prevent="login" class="px-3 synThinFont">
                    <v-text-field 
                        label="Email" 
                        v-model="email"
                        :rules="emailRules"
                    ></v-text-field>
                    <v-text-field 
                        label="Password" 
                        :type="'password'" 
                        v-model=password
                        :rules="passwordRules"
                    ></v-text-field>
                    <div class='red--text mb-1'><span>{{feedback}}</span></div>  
                    <div class="text-center">
                        <a @click="forgotPassword()"> Forgot password?</a>
                    </div>
                    <div class="marginAlignCenter mt-5">
                        <!-- type="submit" -->
                        <v-btn
                            color="syn_green"
                            depressed
                            class=" synThickFont white--text"
                            :loading="loading"
                            type="submit"
                        >
                            Login
                        </v-btn>
                        <!-- <button type="button" @click="login">Click Me!</button> -->
                    </div>
                </v-form>
            </v-card-text>

        </v-card>
        <v-dialog :scrollable="false" v-model="resetPwDialog" width="700">
            <v-card class="ma-0">
                <v-card-title class="headline">
                    Password Reset
                </v-card-title>

                <v-card-text>
                    Please enter your email below and we will send you a link to reset your password.
                </v-card-text>

                <v-card-text>
                    <v-form ref="pwReset" v-on:submit.prevent="pwReset" class="px-3 synThinFont">
                        <v-text-field 
                            label="Email" 
                            v-model="resetEmail"
                        ></v-text-field>
                        <div class="marginAlignCenter mt-4">
                            <v-btn
                                color="syn_green"
                                depressed
                                class="mr-4 synThickFont white--text"
                                :loading="resetLoading"
                                type="submit"
                            >
                                Send
                            </v-btn>
                            
                        </div>
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="red"
                    text
                    @click="resetPwDialog = false"
                >
                    close
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="text-center ma-2">
            <v-snackbar v-model="snackbar" :timeout="timeout">
                {{ snackbarText }}
                <v-btn color="syn_green" text @click="snackbar = false"> Close </v-btn>
            </v-snackbar>
        </div>

        <Overlay :overlay="overlay" />

    </div>
    
    
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import Overlay from '@/components/layout/Overlay'

export default {
    name: 'Login',
    data() {
        return {
            email: null,
            resetEmail: null,
            password: null,
            feedback: null,
            loading: false,
            resetLoading: false,
            emailRules: [
                v => !!v || 'Email is required',
            ],
            passwordRules: [
                v => !!v || 'Password is required',
            ],
            resetPwDialog: false,
            
            snackbarText: null,
            timeout: 4000,
            snackbar: false,
            overlay: false,
        }
    },
    components: {
        Overlay,
    },
    destroyed(){
        // console.log('LOIGN DESTROYED');
    },
    methods: {
        login(){
            this.feedback= null
            this.loading = true
            if(this.email && this.password){
                firebase.auth().signInWithEmailAndPassword(this.email,this.password)
                .then(() => {
                    console.log('Login Successful!');
                    this.loading = false
                    // this.$router.replace({name:'Home'});

                    location.href = "/";
                }).catch(err => {
                    this.loading = false
                    this.feedback = err.message
                })
                this.feedback = null
            } else {
                this.loading = false
                this.feedback="Please fill in both fields."
            }
            
        },
        forgotPassword(){
            this.resetPwDialog = true
        },
        pwReset() {
            this.resetLoading = true
            // console.log(this.resetEmail);
            var emailAddress = this.resetEmail;

            firebase.auth().sendPasswordResetEmail(emailAddress).then(function() {
                // Email sent.
                // this.resetLoading = false
                // this.resetPwDialog = false
                // console.log('email sent');
                

            }).then(()=>{
                this.resetLoading = false
                this.resetPwDialog = false
                this.snackbarText = "Password reset email sent!"
                this.snackbar = true
            }).catch(function(error) {
                // An error happened.
                console.log(error);
            });
            
        }
    }
}
</script>
<style >
.login{
      -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 1s; /* Firefox < 16 */
        -ms-animation: fadein 1s; /* Internet Explorer */
         -o-animation: fadein 1s; /* Opera < 12.1 */
            animation: fadein 1s;
} 

.cardIsHidden{
    display:none;
}

/* .login .v-input .v-label{
    color:black !important;
} */

.login .v-card{
    background-color: rgba(5,25,43,0.8) !important; 
    border: rgba(255,255,255,0.3) 1px solid !important;
}

</style>